import { css, styled } from 'styled-components'

const baseInputStyles = css`
  display: block;
  font-size: 56px;
  line-height: 0.8;
  font-weight: 700;
  text-transform: lowercase;
`

export const TopLineHeading = styled.span`
  ${baseInputStyles}
  letter-spacing: -3px;
  margin-left: -8%;
`
export const BottomLineHeading = styled.span`
  ${baseInputStyles}
  font-size: 80px;
  letter-spacing: -4px;
  margin-right: -8%;
`
